/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const SINGLE_SITE = 'single';
export const GROUP_SITE = 'group';

// Release Statuses
export const NO_SEASON_INFORMATION = 'No Season Information';
export const NEXT_SEASON_NOT_AVAILABLE_INFORMATION = 'Next Season Not Available';
export const FCFS = 'First-come, First-serve';
export const FCFS_FOR_NEXT_SEASON = 'First-come, First-serve for Next Season';
export const BOOK_FOR_NEXT_SEASON = 'Book for Next Season';
export const OPEN_FOR_SEASON = 'Open for Season';

// Release Templates
export const currentlyReleasedTemplate = ({ curReleaseEnd }) =>
    `Can be booked through ${curReleaseEnd}.`;

export const currentlyReleasedForFutureSeasonTemplate = ({
    curReleaseStart,
    curReleaseEnd,
}) => `Availability is released from ${curReleaseStart} through ${curReleaseEnd}.`;

export const currentlyReleasedButNotEffectiveTemplateAbbrev = ({ effectiveDate }) =>
    `Campsites will be available to book beginning ${effectiveDate}.`;

export const currentlyReleasedButNotEffectiveTemplate = ({
    effectiveDate,
    time,
    timeZone,
    curReleaseEnd,
}) =>
    `Campsites will be available to book beginning ${effectiveDate}. On ${effectiveDate} at ${time} ${timeZone}, availability will be released through ${curReleaseEnd}.`;

export const nextReleaseWithStartDateTemplate = ({ nextReleaseStart }) =>
    `Check back on ${nextReleaseStart} to view availability.`;

export const nextReleaseWithEndDateTemplate = ({ nextReleaseDate, nextReleaseEnd }) =>
    `On ${nextReleaseDate}, availability will be released through ${nextReleaseEnd}.`;

export const nextReleaseWithEndDateTemplateWithTime = ({
    nextReleaseDate,
    time,
    timeZone,
    nextReleaseEnd,
}) =>
    `On ${nextReleaseDate} at ${time} ${timeZone}, availability will be released through ${nextReleaseEnd}.`;

export const fcfsWithinBookingWindow = ({ type, nextReleaseDate, nextReleaseEnd }) =>
    `This ${type} is open as first-come, first-served (FCFS) from ${nextReleaseDate} through ${nextReleaseEnd}. During this time it does not offer reservations in advance.`;

export const NOT_RELEASED_TEXT = 'Availability is not released';

export const NO_RELEASE_IN_30_DAYS_TEXT =
    'No new releases at this facility will be made available in the next 30 days.';

export const NO_ADVANCED_RESERVATIONS_TEXT = 'No advanced reservations available.';

export const EARLY_ACCESS_BOOKING_WINDOW_TEXT =
    'If a lottery falls within a reservable period, those stay dates are first available through the lottery only. At the end of the lottery early access period, and if any campsites are still available, those stay dates will be released as described in blue.';
